import { cn } from "@nextui-org/react";
import { useState } from "react";

export const BlurImage = ({
  height,
  width,
  src,
  className,
  objectFit,
  alt,
  layout,
  ...rest
}) => {
  const [isLoading, setLoading] = useState(true);

  return (
    <img
      className={cn(
        "transition duration-300 ease-in-out !rounded-md",
        isLoading ? "blur-sm grayscale" : "blur-0 grayscale-0",
        className
      )}
      onLoad={() => setLoading(false)}
      src={src}
      width={width}
      height={height}
      loading="lazy"
      decoding="async"
      alt={alt ? alt : "Avatar"}
      {...rest}
    />
  );
};
